import { Validators } from '@angular/forms';

export class FormInfo {
  validators: Validators;
  disabled: boolean;
  constructor(required: boolean, validator: Validators) {
    this.disabled = required;
    this.validators = validator;
  }
}
export const ARTICLEVALIDATORS = {
    CREATE: new Map<string, FormInfo>([
      ['id', new FormInfo(true, [])],
      ['dCreation', new FormInfo(true, [])],
      ['idCreateur', new FormInfo(true, [])],
      ['dModification', new FormInfo(true, [])],
      ['idModifieur', new FormInfo(true, [])],
      ['dDesactivation', new FormInfo(true, [])],
      ['idDesativateur', new FormInfo(true, [])],
      ['code', new FormInfo(false, [Validators.required, Validators.maxLength(15)])],
      ['libelle', new FormInfo(false, [Validators.maxLength(40)])],
      ['idSociete', new FormInfo(false, [])],
      ['codeSite', new FormInfo(false, [])],
      ['libelleSite', new FormInfo(false, [])],
      ['pu', new FormInfo(false, [Validators.required, Validators.min(0)])],
      ['codeNa', new FormInfo(false, [Validators.required])],
      ['libelleNa', new FormInfo(false, [Validators.required, Validators.maxLength(255)])],
      ['codeTva', new FormInfo(false, [])],
      ['libelleTva', new FormInfo(false, [])],
      ['codeCg', new FormInfo(true, [Validators.required])],
      ['libelleCg', new FormInfo(true, [Validators.required])],
      ['codeCategorie', new FormInfo(false, [Validators.maxLength(15)])],
      ['libelleCategorie', new FormInfo(false, [Validators.maxLength(255)])],
      ['idSsDomaine', new FormInfo(false, [])],
      ['idSsFamille', new FormInfo(false, [])],
      ['commun', new FormInfo(false, [])]

    ]),
    EDIT: new Map<string, FormInfo>([
        ['id', new FormInfo(true, [])],
        ['dCreation', new FormInfo(true, [])],
        ['idCreateur', new FormInfo(true, [])],
        ['dModification', new FormInfo(true, [])],
        ['idModifieur', new FormInfo(true, [])],
        ['dDesactivation', new FormInfo(true, [])],
        ['idDesativateur', new FormInfo(true, [])],
        ['code', new FormInfo(true, [Validators.required, Validators.maxLength(15)])],
        ['libelle', new FormInfo(false, [Validators.maxLength(40)])],
        ['idSociete', new FormInfo(false, [])],
        ['codeSite', new FormInfo(false, [])],
        ['libelleSite', new FormInfo(false, [])],
        ['pu', new FormInfo(false, [Validators.required, Validators.min(0)])],
        ['codeNa', new FormInfo(false, [Validators.required])],
        ['libelleNa', new FormInfo(false, [Validators.required, Validators.maxLength(255)])],
        ['codeTva', new FormInfo(false, [])],
        ['libelleTva', new FormInfo(false, [])],
        ['codeCg', new FormInfo(true, [Validators.required])],
        ['libelleCg', new FormInfo(true, [Validators.required])],
        ['codeCategorie', new FormInfo(false, [Validators.maxLength(15)])],
        ['libelleCategorie', new FormInfo(false, [Validators.maxLength(255)])],
        ['idSsDomaine', new FormInfo(false, [])],
        ['idSsFamille', new FormInfo(false, [])],
        ['commun', new FormInfo(false, [])]
    ]),
    VISUALIZE: new Map<string, FormInfo>([
        ['id', new FormInfo(true, [])],
        ['dCreation', new FormInfo(true, [])],
        ['idCreateur', new FormInfo(true, [])],
        ['dModification', new FormInfo(true, [])],
        ['idModifieur', new FormInfo(true, [])],
        ['dDesactivation', new FormInfo(true, [])],
        ['idDesativateur', new FormInfo(true, [])],
        ['code', new FormInfo(true, [Validators.required, Validators.maxLength(15)])],
        ['libelle', new FormInfo(true, [Validators.maxLength(40)])],
        ['idSociete', new FormInfo(true, [])],
        ['codeSite', new FormInfo(false, [])],
        ['libelleSite', new FormInfo(false, [])],
        ['pu', new FormInfo(false, [Validators.required, Validators.min(0)])],
        ['codeNa', new FormInfo(false, [Validators.required])],
        ['libelleNa', new FormInfo(false, [Validators.required, Validators.maxLength(255)])],
        ['codeTva', new FormInfo(false, [])],
        ['libelleTva', new FormInfo(false, [])],
        ['codeCg', new FormInfo(true, [Validators.required])],
        ['libelleCg', new FormInfo(true, [Validators.required])],
        ['codeCategorie', new FormInfo(false, [Validators.maxLength(15)])],
        ['libelleCategorie', new FormInfo(false, [Validators.maxLength(255)])],
        ['idSsDomaine', new FormInfo(true, [])],
        ['idSsFamille', new FormInfo(true, [])],
        ['commun', new FormInfo(true, [])]
    ])
  };
